import expirationStorageService from '../../common/expirationStorageService';
import common from '../../common/common';
import _ from 'lodash';

const add = (absoluteUrl) => {
    const RECENTLY_VIEWED_PRODUCTS = 'RECENTLY_VIEWED_PRODUCTS_' + SITE;
    expirationStorageService.init(RECENTLY_VIEWED_PRODUCTS);

    const siteUrl = common.getSiteUrl();
    const unescapedUrl = unescape(absoluteUrl.replace(siteUrl + '/', ''));

    const storedData = expirationStorageService.get({
        key: RECENTLY_VIEWED_PRODUCTS,
    });
    const visitedProducts = storedData === undefined ? [] : storedData;

    if (_.some(visitedProducts, (vp) => vp.url === unescapedUrl)) {
        expirationStorageService.remove({
            key: RECENTLY_VIEWED_PRODUCTS,
            keyName: 'url',
            valueToRemove: unescapedUrl,
        });
    }
    expirationStorageService.add({
        key: RECENTLY_VIEWED_PRODUCTS,
        data: { url: unescapedUrl },
    });
};

export default { add };
